import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e1d2ba4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hud-header trip-view-header d-flex align-items-center container" }
const _hoisted_2 = {
  key: 1,
  class: "d-flex flex-column flex-fill text-center"
}
const _hoisted_3 = { class: "m-0 trip-view-title" }
const _hoisted_4 = { class: "trip-night-count" }
const _hoisted_5 = {
  key: 2,
  class: "faded pe-2 trip-option-trigger"
}
const _hoisted_6 = { class: "modal-row d-flex flex-column align-items-center mt-1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "m-2 w-100" })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "m-2 w-100" })
], -1))
const _hoisted_9 = { class: "modal-row mt-1 flex-grow-1 d-flex flex-column" }
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 0,
  class: "w-100 mt-1 mb-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_trip_option_config = _resolveComponent("trip-option-config")!
  const _component_cost_display = _resolveComponent("cost-display")!
  const _component_display_option_config = _resolveComponent("display-option-config")!
  const _component_fa_icon_modal_trigger = _resolveComponent("fa-icon-modal-trigger")!
  const _component_inline_duration = _resolveComponent("inline-duration")!
  const _component_trip_city_viewer = _resolveComponent("trip-city-viewer")!
  const _component_city_modal_content = _resolveComponent("city-modal-content")!
  const _component_point_list = _resolveComponent("point-list")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["left-hud ed-scrollable", {collapsed: _ctx.collapsed}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.collapsed)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: "trip-back bi-chevron-left mt-auto mb-auto text-center primary-clickable faded",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitBack && _ctx.emitBack(...args)))
          }))
        : _createCommentVNode("", true),
      (!_ctx.collapsed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.modelValue.name), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.nightTotal) + " nights - $" + _toDisplayString(_ctx.costTotal), 1)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.collapsed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_fa_icon_modal_trigger, { "icon-class": "fa-gear" }, {
              default: _withCtx(() => [
                _createVNode(_component_trip_option_config, {
                  modelValue: _ctx.modelValue.options || {},
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateOptions($event)))
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_cost_display, {
                    cost: _ctx.modelValue.cost || 0,
                    "onUpdate:cost": _ctx.scheduleCostUpdate
                  }, null, 8, ["cost", "onUpdate:cost"])
                ]),
                _hoisted_7,
                _createVNode(_component_display_option_config, {
                  class: "mt-1",
                  modelValue: _ctx.displayOptions,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.displayOptions) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("textarea", {
                    class: "form-control flex-grow-1",
                    value: _ctx.modelValue.notes,
                    onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.scheduleNoteUpdate && _ctx.scheduleNoteUpdate(...args))),
                    placeholder: "Notes, Ideas, and More!"
                  }, null, 40, _hoisted_10)
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("i", {
        class: _normalizeClass(["fas primary-clickable faded collapser pe-2 text-center", {'fa-caret-left': !_ctx.collapsed, 'fa-caret-right': _ctx.collapsed}]),
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.collapsed = !_ctx.collapsed))
      }, null, 2)
    ]),
    (!_ctx.collapsed)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_11))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_point_list, {
        class: "trip-city-list",
        modelValue: _ctx.normalizedPoints,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.normalizedPoints) = $event)),
        onAddSearched: _ctx.addSearched,
        "item-class": "tv-city",
        "pad-all": ""
      }, {
        inline: _withCtx(({point, updatePoint}) => [
          _createVNode(_component_inline_duration, {
            class: "city-night-count",
            mode: "single",
            suffix: {singular: 'night', plural: 'nights'},
            modelValue: point.nights,
            "onUpdate:modelValue": _ctx.generateNightCbObject(point, updatePoint).cb,
            buttonText: _ctx.getCityNightsButtonText(point.id)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "buttonText"])
        ]),
        expansion: _withCtx(({point, updatePoint}) => [
          _createVNode(_component_trip_city_viewer, {
            modelValue: point,
            "onUpdate:modelValue": updatePoint
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        settings: _withCtx(({point, updatePoint}) => [
          _createVNode(_component_city_modal_content, {
            modelValue: point,
            "onUpdate:modelValue": updatePoint
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }, 8, ["modelValue", "onAddSearched"])
    ], 512), [
      [_vShow, !_ctx.collapsed]
    ])
  ], 2))
}